module.exports = __webpack_public_path__ + "media/images/done-icon-c5add31099b85ada0973dfc89159ed28.png";